import currency from 'currency.js'

export const BRL = (value?: number | string) =>
  currency(value || '', { symbol: 'R$ ', decimal: ',', separator: '.' })
